import script from "./PreloaderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreloaderPage.vue?vue&type=script&setup=true&lang=js"

import "./PreloaderPage.vue?vue&type=style&index=0&id=38af7c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38af7c14"]])

export default __exports__